import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/(app)/_lib/auth-shell.tsx");
